export const getCurrencySymbol = (currencyCode: string): string => {
  const currencySymbols: { [key: string]: string } = {
    'EUR': '€',
    'USD': '$',
    'GBP': '£',
    'JPY': '¥',
    'CNY': '¥',
    'CHF': 'CHF',
    'CAD': 'C$',
    'AUD': 'A$',
    'SEK': 'kr',
    'NOK': 'kr',
    'DKK': 'kr',
    'PLN': 'zł',
    'CZK': 'Kč',
    'HUF': 'Ft',
    'RON': 'lei',
    'BGN': 'лв',
    'HRK': 'kn',
    'RSD': 'дин',
    'RUB': '₽',
    'UAH': '₴',
    'BRL': 'R$',
    'MXN': '$',
    'INR': '₹',
    'KRW': '₩',
    'SGD': 'S$',
    'THB': '฿',
    'TRY': '₺',
    'ZAR': 'R',
    'NZD': 'NZ$',
  };

  return currencySymbols[currencyCode] || currencyCode;
};

export const formatPrice = (amount: number, currencyCode: string, showCurrency: boolean = true, significantDigits: number = 2): string => {
  
  const roundedAmount = Math.round(amount * 100) / 100;
  const formattedAmount = roundedAmount % 1 === 0 ? roundedAmount.toFixed(0) : roundedAmount.toFixed(significantDigits);
  if (!showCurrency) {
    return formattedAmount;
  }
  
  const symbol = getCurrencySymbol(currencyCode);
  
  const prefixCurrencies = ['USD', 'GBP', 'CAD', 'AUD', 'SGD', 'NZD', 'BRL', 'MXN'];
  
  if (prefixCurrencies.includes(currencyCode)) {
    return `${symbol}${formattedAmount}`;
  }
  
  return `${formattedAmount}${symbol}`;
};
